__turbopack_context__.v({
  "activity-indicator-wrapper": "U2ylSG_activity-indicator-wrapper",
  "activity-indicator-wrapper--active": "U2ylSG_activity-indicator-wrapper--active",
});
